module.exports = __webpack_public_path__ + "img/hr-concrete-hole-decal-19.dd923249.png";